<template>
    <li :class="isActive ? 'active' : ''" ref="element">
        <a :href="'#' + ancorElementId" class="d-flex overflow-auto text-decoration-none">
            <Icon type="arrow-right"/>
            <p>{{ text }}</p>
        </a>
    </li>
    
</template>

<script>
import Icon from "common/js/vue/image/icon.vue";
import AncorNavigation from "../../script/ancorNavigation"

export default {
    name: "PaSidanNavigationListElement",
    props: {
        ancorElementId: String,
        text: String,
        isActive: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    components: {
        Icon
    },
    mounted() {
        AncorNavigation.updateScript(this.$refs.element);
    }
};
</script>